import { render, staticRenderFns } from "./LaudoBenfeitoriasModal.vue?vue&type=template&id=258d84c6&scoped=true&lang=pug"
import script from "./LaudoBenfeitoriasModal.vue?vue&type=script&lang=js"
export * from "./LaudoBenfeitoriasModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoBenfeitoriasModal.vue?vue&type=style&index=0&id=258d84c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258d84c6",
  null
  
)

export default component.exports